module.exports = __webpack_public_path__ + "img/img_10.1b09c844.png";